import React from "react";
import "../styling/JesusCoin.css";
import bottomDenarii from "../images/bottomDenari.jfif"; 
import topDenari from "../images/topDenari.jpg";
import topDenari2 from "../images/topDenarii.jpg";
function JesusCoin(){
    return(
<div className="hvFullPage">
    <div className="topDenari">
        <img src={topDenari} alt="Denarius Coin" id="topDenariImage" />
        <img src={topDenari2} alt="Denarius Coin" id="topDenariImage" />
    </div>
    <div className="content">   
        <h1 className="hvTitle">

        God’s Perfect Timing: The Denarius and Jesus’ Profound Lesson
        </h1>


        <div className="hvSection">
        <h3 className="middle">Introduction</h3>
        <p>
            Throughout history, God has orchestrated events with incredible precision, ensuring that His message is revealed at the perfect time. One of the most striking examples of this divine timing is found in Jesus’ famous teaching on taxes and allegiance in Matthew 22:19-21. In this moment, Jesus asked for a denarius, a Roman coin that happened to bear the image of Caesar Tiberius—one of the few coins in history to ever feature the face of a living emperor. This small yet significant detail reveals God's perfect plan in action.
        </p>
        </div>


        <div className="hvSection">
        <h3 className="middle">The Denarius: A Coin of Uncommon Timing</h3>
        <p>
            The denarius Jesus used in this teaching was not just any coin—it was a silver Roman coin minted between 14 AD and 37 AD, during the reign of Tiberius Caesar. While many Roman coins existed before and after this period, few carried the portrait of a reigning emperor, as earlier denarii often depicted gods, symbols, or past rulers.
        </p>
        <p>
            Had Jesus been born just a few decades earlier or later, the coin available may not have carried such a striking symbol for His teaching. But at that precise moment, the denarius of Tiberius was in circulation—making it the perfect object lesson for Jesus to reveal a deeper truth about God’s kingdom.
        </p>
        </div>


        <div className="hvSection">
        <h3 className="middle">“Give to Caesar What Is Caesar’s” – A Divine Teaching</h3>
        <p>
            When the Pharisees and Herodians tried to trap Jesus by asking whether it was lawful to pay taxes to Caesar, He responded with divine wisdom:
        </p>
        <p>
            📖 Matthew 22:19-21 (NIV)<br />
            "Show me the coin used for paying the tax." They brought Him a denarius, and He asked them, "Whose image is this? And whose inscription?"<br />
            "Caesar’s," they replied.<br />
            Then He said to them, "So give back to Caesar what is Caesar’s, and to God what is God’s."
        </p>
        <p>
            At that moment, Jesus used the very denarius—a coin carrying the image and inscription of Caesar—to illustrate an eternal principle: Earthly governments have their role and authority, and we should honor them accordingly. But our ultimate allegiance belongs to God because we bear His image (Genesis 1:27).
        </p>
        </div>

        <div className="hvSection">
        <h3 className="middle">God’s Timing in Every Detail</h3>
        <p>
            The fact that Jesus used a coin featuring one of the few emperors to ever have his face on currency is no coincidence. It demonstrates how God’s timing is perfect: Jesus came at the right moment in history (Galatians 4:4 – "When the set time had fully come, God sent His Son"). The denarius of Tiberius was available at just the right time to illustrate a timeless truth.
        </p>
        <p>
            The message of the coin aligns perfectly with Jesus’ teaching—Caesar’s image on a coin meant it belonged to him, but we, who are made in God’s image, belong to Him. If Jesus had been born in another era, this visual lesson might not have been possible. But God ensured that everything aligned perfectly for Jesus to teach this profound truth in a way that would be remembered for generations.
        </p>
        </div>
        <div className="hvSection">
        <h3 className="middle">What This Means for Us Today</h3>
        <p>
            Just as God orchestrated the details of Jesus’ teaching with perfect timing, He also orchestrates the events of our lives with divine precision. We may not always understand His timing, but He is always at work behind the scenes.
        </p>
        <p>
            If you’re waiting for an answer to prayer, trust that God’s timing is never early, never late—always perfect. If you feel like things in your life are uncertain, remember that God controls the details, just as He controlled history leading up to Jesus’ teaching. Just as Jesus pointed out that the coin belonged to Caesar because it bore his image, we must remember that we belong to God because we bear His image.
        </p>
        </div>
        <div className="hvSection">
        <h3 className="middle">Conclusion: A Coin, a Lesson, and God’s Sovereignty</h3>
        <p>
            The story of the denarius in Jesus’ teaching is a powerful reminder that God is always in control. The fact that this specific coin—a rare example of one bearing a living emperor’s face—was in circulation at the exact time of Jesus' ministry is not just historical trivia; it is a testimony of God's perfect orchestration of history. Just as He aligned every detail for Jesus’ teaching, He is aligning every detail in your life for His greater purpose. Trust His timing, for it is always perfect.
        </p>
        </div>
    </div> 
    <div className="bottomDenarius">
        <img src={bottomDenarii} alt="Denarius Coin" id="bottomDenariImage" />
    </div>
    
</div>
    );
}
export default JesusCoin; 
